import { render, staticRenderFns } from "./social-links.vue?vue&type=template&id=8257dc32"
import script from "./social-links.vue?vue&type=script&lang=js"
export * from "./social-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports